import m = require("mithril");
import {Application} from "./app";
import {Questionary} from "../model/questionary";
import {Vnode} from "mithril";
import h from "./design";

export class LangView {

    // https://cs.wikipedia.org/wiki/Seznam_k%C3%B3d%C5%AF_ISO_639-1
    static readonly translatedLocales = {
        ar: 'عربي',
        bg: 'български език',
        cs: 'Čeština',
        de: 'Deutsch',
        en: 'English',
        es: 'Español',
        fa: 'Persian',
        fr: 'Le français',
        he: 'עִברִית',
        hr: 'Hrvatski',
        hu: 'Magyar',
        it: 'Italiano',
        ja: '日本語',
        km: 'Cambodian',
        ko: 'Korean',
        lt: 'Latviski',
        lv: 'Latviešu',
        ms: 'Malaysian (Bahasa)',
        nl: 'Nederlands',
        pt: 'Português',
        pl: 'Polski',
        ro: 'Română',
        ru: 'Русский',
        sk: 'Slovenčina',
        tw: 'Chinese Hokkien',
        vi: 'Tiếng Việt',
        zh: 'Chinese',
    };

    private app: Application;
    private questionary: Questionary;

    constructor(app: Application, questionary: Questionary) {
        this.app = app;
        this.questionary = questionary;
    }

    private viewPreviousButton(lastChosenLanguage: string): Vnode|null {
        return m("button.btn.large.outline.secondary", {
            onclick: () => {
                this.questionary.dictionary!.locale = lastChosenLanguage;
                this.questionary.saveLang();
                this.app.view();
            },
            title: this.questionary.renderText(this.questionary.messages.get('backButton')),
            tabindex: 3,
        }, [
            m('i.icon.icon-chevron-left', {}, ''),
            m('span', {}, this.questionary.messages.get('backButton'))
        ]);
    }

    /**
     *  Loads flags stylesheet (big) just in time
     */
    oncreate(): void {
        if (!document.getElementById('stylesheet-flags')) {
            $('head').append('<link rel="stylesheet" href="//s.nms-mr.com/w/se2/flags.css" type="text/css" id="stylesheet-flags"/>');
        }
    }

    view() {
        const lastChosenLanguage = this.questionary.messages.getLocale();
        const locales = this.questionary.dictionary!.locales();
        const languages = [];

        for (let i in locales) {
            const locale = locales[i];
            languages.push(
                m(
                    'span.lang',
                    {
                        onclick: () => {
                            this.app.messages.setLocale(locale);
                            this.questionary.dictionary!.locale = locale;
                            this.questionary.saveLang();
                            this.app.view();
                        }
                    },
                    [
                        m('.flag.flag-large.flag-'+locale),
                        m('span', { }, this.translateLocale(locale)),
                    ]
                )
            );
        }

        const headerText = lastChosenLanguage ? this.questionary.messages.get('selectLanguage') : 'Select language';

        return m('.form.form-select-lang.appear-left', {}, [
            m('.content', {}, [
                m("p", {}, this.questionary.renderText(headerText)),
                m('.langs', languages),
            ]),
            m('.controls', {}, [
                m(".control-group", {}, [
                    lastChosenLanguage ? this.viewPreviousButton(lastChosenLanguage) : null,
                ]),
            ]),
        ])

    }

    private getQuestionClass(): string {
        return window.innerWidth < h.BC.md ? '.question.has-primary-background.fade-in' : '.question.fade-in';
    }

    private translateLocale(lang: string) {
        // @ts-ignore  // should check if lang exist
        return LangView.translatedLocales[lang] ? LangView.translatedLocales[lang] : lang.toUpperCase();
    }
}
